export const TYPEWRITER_TIMINGS = {
    type: 36,
    hold: 1800,
    delete: 18,
    gap: 220,
} as const;

export interface TypewriterState {
    promptIndex: number;
    displayedText: string;
    phase: 'typing' | 'deleting';
}

export interface TypewriterStep {
    delay: number;
    nextState: TypewriterState;
}

export const INITIAL_TYPEWRITER_STATE: TypewriterState = {
    promptIndex: 0,
    displayedText: '',
    phase: 'typing',
};

/**
 * 计算提示词打字循环的下一帧；保持为纯函数，方便精确验证时序和边界。
 */
export function getNextTypewriterStep(
    state: TypewriterState,
    prompts: readonly string[],
): TypewriterStep | null {
    if (prompts.length === 0) return null;

    const promptIndex = state.promptIndex % prompts.length;
    const targetText = prompts[promptIndex];

    if (state.phase === 'typing') {
        if (state.displayedText.length < targetText.length) {
            return {
                delay: TYPEWRITER_TIMINGS.type,
                nextState: {
                    ...state,
                    promptIndex,
                    displayedText: targetText.slice(0, state.displayedText.length + 1),
                },
            };
        }

        return {
            delay: TYPEWRITER_TIMINGS.hold,
            nextState: { ...state, promptIndex, phase: 'deleting' },
        };
    }

    if (state.displayedText.length > 0) {
        return {
            delay: TYPEWRITER_TIMINGS.delete,
            nextState: {
                ...state,
                promptIndex,
                displayedText: state.displayedText.slice(0, -1),
            },
        };
    }

    return {
        delay: TYPEWRITER_TIMINGS.gap,
        nextState: {
            promptIndex: (promptIndex + 1) % prompts.length,
            displayedText: '',
            phase: 'typing',
        },
    };
}
